const dynamicList = [
  {
    type: 1,
    base: {
      user: {
        unify_id: 1335409,
        u_name: '11－Tina',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv4.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 172期毕业学员',
          alias: 'betterWE减脂营 172期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1335409'
        }
      },
      title: '感恩遇见茗茗',
      desc: '21天，教我们避开减脂、营养路上的坑，未来广阔的大路，无尽的知识海洋等我们探索……\n@营养师茗茗:谢谢您对我的每餐打卡都仔细、贴心地指导并回复......\n每次看到您对我的体测数据分析写那么多内容好感动......\n21天，收获很多......\n从最基础的营养知识开始，带我们了解三大营养素，教会我们211、外食聚餐等一系列生活化的问题解决法则，关键是不饿肚子，无论是生理，还是心理，都让自己能慢慢找到更好的自己.....\n经过了元旦假期，我不但没有长肉，还继续慢慢地掉称、纬度减小ing.....\n谢谢您一步步地带着我、陪着我向更健康的自己而努力，感恩遇见😗',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704439937903_jpg_wh=1919_1440.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704446166485_jpg_wh=1919_1440.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704438583858_jpg_wh=1920_2560.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704444472870_png_wh=612_612.png',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2024-01-05 15:04:28'
    },
    detail: {
      id: 260486,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 196823,
          group_id: 260486,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 196824,
          group_id: 260486,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1155827,
        u_name: '1-LOVE雅',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv5.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 163期毕业学员',
          alias: 'betterWE减脂营 163期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1155827'
        }
      },
      title: '减脂初体验➕结营感言',
      desc: '84天减脂营经历结束啦，不知不觉从开始减脂到现在已经快三个月了，首先特别感谢营养师羊羊老师，在营期间经过羊羊老师指导，体重下降22.8斤，腰围下降17厘米，自己都觉得不可思议，接下来再来说说经历：\n我是一个二胎宝妈，2019年生完老大当时身材还没怎么变形，所以完全忽略了产后康复这回事，生活上也是很放肆吃重油高糖食品，直到2021年生完老二，身材一直没有恢复，而且一直持续不断涨胖，直到今年体重比我怀孕时还重，肚子像怀孕时一样大，看到网上各类减脂办法觉得太狠了，完全做不到，以为自己就这样了，直到被女儿说我胖的像阿姨一样，才觉得减肥，两年前就在抖音刷到修贤老师的放纵减肥法，觉得有点意思，但是一直观望从来没有实际行动过，因为觉得不可能吃瘦，从来没有过减脂经历的我心里想我这么爱吃的人怎么可能减脂成功呢，再加上现在市面上五花八门的减肥方法，还有一些贴别狠的节食疯狂运动使我对减脂这件事特别排斥，一直到今年体重疯狂上涨到感觉身体出现明显不适感，才坚定下定决心减脂，为什么选择我们减脂营呢，因为这是目前为止我所了解到的所有减脂方法中觉得我唯一能坚持的，也是最贴近生活的减脂方法，像节食减肥，生酮减肥，什么液断，蛋断，先不说健不健康，有可能一天两天能坚持，但是不可能永远不吃饭，根本不现实，了解到放纵减脂后想着不管到底能不能减肥，这样的饮食生活至少是健康的，就当是改掉自己之前暴饮暴食的坏毛病了，刚开始也是抱着试一试的心态，入营后第一天开营大会老师告诉我们正确饮食方式和食材搭配方法，但是并不限制具体一定要吃什么食物，食材自己根据生活现状如何方便如何搭配，比较自由，不像那些给你固定食谱的那种，我算是比较幸运的，入营就稳定掉秤的那种，不知道是不是第一次减脂的原因，以前没有过那些错误的乱七八糟的减脂经历，入营第一个星期，四天的时间减了六斤，当时第一反应就是称坏了吧，只是改变一下饮食怎么可能有这样的效果，第五天早上又再次称重体重又上涨两斤，心里又想着这称是真坏了吧，咋的一天一个重量，一个星期结束，到第七天，确定掉秤六斤，而且从此以后体重稳定下降，没有反弹过，再到后来也就挺有规律的掉秤，每次都是夸夸掉个几斤，然后体重数字不变，围度在缩小个几厘米，然后在维持一点时间，基本上就是一个星期掉体重，一个星期缩小围度，再维持稳定一个星期，然后再重新开始掉体重缩小围度，这样的规律如果不是老师反复强调不要老是盯着体重秤上的数字一定要关注围度，不然一定会觉得体重不是咔咔掉的吗怎么十来天没动了，肯定是卡平台了，然后就会焦虑，觉得老师说的最对的一句话就是：平台期不可怕，就怕平台期人在焦虑的心态下选择错误的方式，而且让你焦虑的还不是真正的平台期，在营期间经过老师指导，重新对食物有了新的认知，了解到食物和食物之间的关系，什么样的搭配起到什么样的反应，最接近生活化的方式，不知不觉瘦了，觉得特别神奇，我是从头到尾都是使用的211方法（一拳主食➕一拳蛋白质➕两拳蔬菜），中间两次经期微调了两天，一直稳定掉秤，从刚开始130斤的大基数体重到现在107斤，现在属于小基数掉秤比较缓慢了，但是重点是重来没有反弹过，期间也有放纵餐也有聚会和很长一段时间加班熬夜吃食堂，都是按照老师给的外食建议去吃是真的没有反弹过，这些都要感谢羊羊老师，重要的是减脂营的老师不会像网上其它那些博主一样上来就推荐一大堆各类补剂代餐之类的减脂产品，羊羊老师从来不让我们买什么减脂产品，哪怕是他们商城自己的产品如果你身体不缺，老师也不推荐购买，正确吃好一日三餐就够了，佛系到怀疑自己是不是进了一个假的减脂营，最后分享一下经验：食材选择尽量选择新鲜的蔬菜粗杂粮，（粗粮不要细做），能自己烹饪最好，可能有些宝子选择的也是粗杂粮，但是是加工过的，我是从头到尾只吃过一两次加工食品，虽然配料表很干净，但是饱腹感和抗饿感那是天差地别，烹饪方式：清蒸，小炒，少油，少盐，只要是自己做，哪怕偶尔手抖发挥失常油放多一点也比外卖要好的多，最后最重要的一点就是心态，一定要放平心态保持平常心对待减脂，开始减脂了就一定要坚持，不要怀疑，相信自己相信老师，有什么疑惑多和老师沟通，有的时瘦的慢一点没有关系，只在我们在慢慢变好总会拿到自己想要的结果，心态是最重要的，有些时候在美食诱惑面前吃不吃，吃什么都是自己一念之间的事，自己心态不平衡，老师的方法再好再有效也没有用，最后再次感谢营养师羊羊老师84天减脂营的陪伴一个新的健康的生活方式已经养成，效果体验非常明显，虽然还没有达到自己的目的，虽然结营了但是我们的行动还没有结束，继续坚持一定会得到自己想要得结果，宝子们我们陪伴营再相见，加油，减脂人！',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704269099069557_jpg_wh=523_697',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704269099411007_jpg_wh=1280_1280',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704269099799045_jpg_wh=1536_1534',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704269101011034_jpg_wh=4096_4096',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2024-01-03 16:05:01'
    },
    detail: {
      id: 259753,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 196092,
          group_id: 259753,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1155827,
        u_name: '1-LOVE雅',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv5.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 163期毕业学员',
          alias: 'betterWE减脂营 163期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1155827'
        }
      },
      title: '第一次减脂初体验',
      desc: '84天减脂营经历结束啦，不知不觉从开始减脂到现在已经快三个月了，首先特别感谢营养师羊羊老师，在营期间经过羊羊老师指导，体重下降22.8斤，腰围下降17厘米，自己都觉得不可思议，接下来再来说说经历：\n我是一个二胎宝妈，2019年生完老大当时身材还没怎么变形，所以完全忽略了产后康复这回事，生活上也是很放肆吃重油高糖食品，直到2021年生完老二，身材一直没有恢复，而且一直持续不断涨胖，直到今年体重比我怀孕时还重，肚子像怀孕时一样大，看到网上各类减脂办法觉得太狠了，完全做不到，以为自己就这样了，直到被女儿说我胖的像阿姨一样，才觉得减肥，两年前就在抖音刷到修贤老师的放纵减肥法，觉得有点意思，但是一直观望从来没有实际行动过，因为觉得不可能吃瘦，从来没有过减脂经历的我心里想我这么爱吃的人怎么可能减脂成功呢，再加上现在市面上五花八门的减肥方法，还有一些贴别狠的节食疯狂运动使我对减脂这件事特别排斥，一直到今年体重疯狂上涨到感觉身体出现明显不适感，才坚定下定决心减脂，为什么选择我们减脂营呢，因为这是目前为止我所了解到的所有减脂方法中觉得我唯一能坚持的，也是最贴近生活的减脂方法，像节食减肥，生酮减肥，什么液断，蛋断，先不说健不健康，有可能一天两天能坚持，但是不可能永远不吃饭，根本不现实，了解到放纵减脂后想着不管到底能不能减肥，这样的饮食生活至少是健康的，就当是改掉自己之前暴饮暴食的坏毛病了，刚开始也是抱着试一试的心态，入营后第一天开营大会老师告诉我们正确饮食方式和食材搭配方法，但是并不限制具体一定要吃什么食物，食材自己根据生活现状如何方便如何搭配，比较自由，不像那些给你固定食谱的那种，我算是比较幸运的，入营就稳定掉秤的那种，不知道是不是第一次减脂的原因，以前没有过那些错误的乱七八糟的减脂经历，入营第一个星期，四天的时间减了六斤，当时第一反应就是称坏了吧，只是改变一下饮食怎么可能有这样的效果，第五天早上又再次称重体重又上涨两斤，心里又想着这称是真坏了吧，咋的一天一个重量，一个星期结束，到第七天，确定掉秤六斤，而且从此以后体重稳定下降，没有反弹过，再到后来也就挺有规律的掉秤，每次都是夸夸掉个几斤，然后体重数字不变，围度在缩小个几厘米，然后在维持一点时间，基本上就是一个星期掉体重，一个星期缩小围度，再维持稳定一个星期，然后再重新开始掉体重缩小围度，这样的规律如果不是老师反复强调不要老是盯着体重秤上的数字一定要关注围度，不然一定会觉得体重不是咔咔掉的吗怎么十来天没动了，肯定是卡平台了，然后就会焦虑，觉得老师说的最对的一句话就是：平台期不可怕，就怕平台期人在焦虑的心态下选择错误的方式，而且让你焦虑的还不是真正的平台期，在营期间经过老师指导，重新对食物有了新的认知，了解到食物和食物之间的关系，什么样的搭配起到什么样的反应，最接近生活化的方式，不知不觉瘦了，觉得特别神奇，我是从头到尾都是使用的211方法（一拳主食➕一拳蛋白质➕两拳蔬菜），中间两次经期微调了两天，一直稳定掉秤，从刚开始130斤的大基数体重到现在107斤，现在属于小基数掉秤比较缓慢了，但是重点是重来没有反弹过，期间也有放纵餐也有聚会和很长一段时间加班熬夜吃食堂，都是按照老师给的外食建议去吃是真的没有反弹过，这些都要感谢羊羊老师，重要的是减脂营的老师不会像网上其它那些博主一样上来就推荐一大堆各类补剂代餐之类的减脂产品，羊羊老师从来不让我们买什么减脂产品，哪怕是他们商城自己的产品如果你身体不缺，老师也不推荐购买，正确吃好一日三餐就够了，佛系到怀疑自己是不是进了一个假的减脂营，最后分享一下经验：食材选择尽量选择新鲜的蔬菜粗杂粮，（粗粮不要细做），能自己烹饪最好，可能有些宝子选择的也是粗杂粮，但是是加工过的，我是从头到尾只吃过一两次加工食品，虽然配料表很干净，但是饱腹感和抗饿感那是天差地别，烹饪方式：清蒸，小炒，少油，少盐，只要是自己做，哪怕偶尔手抖发挥失常油放多一点也比外卖要好的多，最后最重要的一点就是心态，一定要放平心态保持平常心对待减脂，开始减脂了就一定要坚持，不要怀疑，相信自己相信老师，有什么疑惑多和老师沟通，有的时瘦的慢一点没有关系，只在我们在慢慢变好总会拿到自己想要的结果，心态是最重要的，有些时候在美食诱惑面前吃不吃，吃什么都是自己一念之间的事，自己心态不平衡，老师的方法再好再有效也没有用，最后再次感谢营养师羊羊老师84天减脂营的陪伴一个新的健康的生活方式已经养成，效果体验非常明显，虽然还没有达到自己的目的，虽然结营了但是我们的行动还没有结束，继续坚持一定会得到自己想要得结果，宝子们我们陪伴营再相见，加油，减脂人！',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704265585343347_jpg_wh=523_697',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 1,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2024-01-03 15:06:25'
    },
    detail: {
      id: 259744,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 196081,
          group_id: 259744,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1283306,
        u_name: '小璐-23',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv4.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 169期毕业学员',
          alias: 'betterWE减脂营 169期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1283306'
        }
      },
      title: '这里我简单分享一下我的结营收获和感想',
      desc: '这是我参加的第二期减脂营，上一期减脂营从57.1减到55.5，这一期从55.5到今天早上的53.2，本来有点担心这一期会不会没什么效果，因为我本身是有内分泌问题的，而且又是个运动渣渣、很不爱运动的一个人，这一期运动的次数也是屈指可数，有的时候外食三要素也搭配的不好，不过我很少加餐，可能就一两次，能取得这样的减脂效果，真的很开心～这段期间真的很感谢亲爱的莎莎，每餐认真指导，在群里为大家答疑解惑，在更新体测数据之后莎莎总是能及时了解到我的情况并有针对性地进行调整，在我有几天体重出现起伏的时候鼓励我，爱你哟，之后我一定会认真喝水，搭配上运动，好好泡脚 ，努力早睡，希望下一期结束的时候可以来和莎莎分享一下我已经达成一开始定的目标，说不定有什么问题还要经常来骚扰莎莎😘这一期很开心遇到莎莎和亲爱的大家，祝大家都能减脂成功，越来越瘦，越来越美～@莎莎',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704258934279_jpg_wh=1280_1280.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704259327013_jpg_wh=1179_1722.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704255697573_jpg_wh=2291_2291.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2024-01-03 10:40:21'
    },
    detail: {
      id: 259626,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 195953,
          group_id: 259626,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 195954,
          group_id: 259626,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1013797,
        u_name: 'x-41',
        u_img: 'https://cdnvue.gymcity.com.cn/uploads/pub-red-logo',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 161期毕业学员',
          alias: 'betterWE减脂营 161期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1013797'
        }
      },
      title: '',
      desc: '来参加减脂营，除了收获体重下降，也学习了关于营养搭配的问题，现在养成习惯，每次吃饭第一口都是在找蔬菜，吃到8分饱就停下来。之前一天喝一杯600ml水，现在也能坚持喝完4杯。在家里吃饭，蔬菜也改成比肉菜多，现在也会虽然减脂的速度不快，但是过程完全不会痛苦，长期坚持，一定会看到明显的效果',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703650455018_png_wh=2291_2291.png',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 1,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-27 11:27:58'
    },
    detail: {
      id: 257495,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 193780,
          group_id: 257495,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 193781,
          group_id: 257495,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1089536,
        u_name: 'Stefanie.Z',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv3.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 160期毕业学员',
          alias: 'betterWE减脂营 160期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1089536'
        }
      },
      title: '终于迈出了最重要的一步！',
      desc: '因为之前参加过一次，涉及在国庆，就放弃了。\n这次虽然打卡不及时，但是学到了方法后默默的全程自我激励，也感谢六六老师全程陪伴和鼓励支持。祝大家越来越瘦',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703643207250_jpg_wh=791_1070.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703646002135_jpg_wh=2160_2160.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 4,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-27 09:01:16'
    },
    detail: {
      id: 257406,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 193687,
          group_id: 257406,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 193688,
          group_id: 257406,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1126220,
        u_name: 'Mmly',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv3.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 170期毕业学员',
          alias: 'betterWE减脂营 170期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1126220'
        }
      },
      title: '',
      desc: '1.我是谁 ：Mmly\n2.导致我肥胖的原因：产后激素紊乱，食欲增加，爱吃油炸辛辣重油食物\n我用过的减肥方法：节食减肥\n3.为什么想减肥： 穿衣服不好看，总是被周围的人说胖，没有自信 \n让我决定参加减脂营的原因：修贤老师的团队带领学员成功的案例\n4.通过什么渠道了解的减脂营：抖音修贤老师发的视频\n5.减脂营最吸引我的是什么：不用大量运动，有营养师监督指导\n6.我在减脂营的收获：\n第一，数字方面：体重减少6.6斤，腰围减少9厘米，腿围减少2.5厘米\n第二，身体方面：吃饱但吃的没有负担的感觉很舒服，自己肠胃也越来越有动力，皮肤也在慢慢变好，跟着臻臻营养师了解的玉米须水和晚上泡脚让我的失眠和浮肿也在改善；\n第三，心理方面：这么多年终于看到自己的的体重变化了，看着不断减少的数字和慢慢平坦的小腹，内心很有成就感，自信心一点点也恢复，开始相信自己也是可以减肥成功的，中间虽然有体重回升和不变的情况，但是老师的指导下我明白了原理，不再因为一两斤的变化而焦虑啦；\n第四，健康意识方面，在整个营期，老师们耐心回答我的每一个问题，不断的告诉我们健康不只是体重，我也从学习中真正的了解到了健康合理饮食的理念，也会积极的向身边人推荐这样的健康饮食观念！',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703225307284_jpg_wh=800_800.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703221418872_jpg_wh=889_1280.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703220709562_jpg_wh=600_800.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 3,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-22 11:33:06'
    },
    detail: {
      id: 256264,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192529,
          group_id: 256264,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 192530,
          group_id: 256264,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1297730,
        u_name: '&',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv1.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 170期毕业学员',
          alias: 'betterWE减脂营 170期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1297730'
        }
      },
      title: '',
      desc: '第一次参加这种线上减脂营，感谢奔奔老师还有两位餐卡老师，绫绫老师跟秀虹老师，每餐会告诉我哪些吃多吃少了，还给了我很多补救建议，和修改建议，在3位老师的指导下，现在的我一眼就可以分辨蛋白质主食和膳食纤维，哪怕是公司盒饭现在稍加修改也可以变成一份营养餐了。',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703134545814_jpg_wh=1080_1528.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703129515446_jpg_wh=1080_2340.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703134370613_jpg_wh=1920_1080.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703132628881_jpg_wh=1919_1439.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703133930925_jpg_wh=2291_2291.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-21 11:14:21'
    },
    detail: {
      id: 256049,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192297,
          group_id: 256049,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 192298,
          group_id: 256049,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1241567,
        u_name: 'shang浩嘉',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv3.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 170期毕业学员',
          alias: 'betterWE减脂营 170期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1241567'
        }
      },
      title: '21天减脂营  减重2.2斤，腰围减少4㎝',
      desc: '21天 最大的感受就是饮食方面的改变，从开始的不知道怎么吃到现在学会了搭配，还有基本改变了以前爱吃零食（主要是爱吃甜食）的习惯  到现在不怎么吃零食了也不会想去吃了   在思想上的话更加明白健康的重要性   不在一味的去在意自己的体重了    更重要的是关注了是否吃得健康  身体有没有往好的方向发展  心情也变得更好了  不像之前哪样吃了点东西就负罪感满满的 总是很自责   然后就不规律的饮食    现在回想以前那些做法都是错误的    我相信只要我一直坚持下去  我会收获一个不一样的自己     我告诉自己21天的结业  不代表我的减脂就结束了  而是我的健康生活才刚刚开始  我会继续努力加油的  💪💪💪 最后感谢减脂营的老师们对我的指导和鼓励   谢谢你们[合十][合十]',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703093955695_jpg_wh=1080_305.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 1,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-20 23:07:06'
    },
    detail: {
      id: 255986,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192234,
          group_id: 255986,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 192235,
          group_id: 255986,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1265057,
        u_name: '林～17号',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv1.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 170期毕业学员',
          alias: 'betterWE减脂营 170期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1265057'
        }
      },
      title: '结营啦，减重的感觉真好',
      desc: '很感谢营养师的陪伴，关注修贤一段时间，翻看了她早起的一个个视频，基础的健康瘦身理念是我能接受也是喜欢的。我从2019年备考开始胖起来，1年过百，2年过110，到2021年已经稳稳120，也就是稳稳胖了3年多。吃代餐不适合我这胃会不舒服的，运动每次跑5公里也没见瘦。这21天，我从121斤瘦到115斤，算是这几年比较低的体重了。\n\n    我发现我很多饮食上不科学的地方，精致碳水、过量的蛋白质、高热量的零食等，平时虽然略有注意，但没有这么认真去规划每一天的饮食，就这么一天天胖起来。现在想要一天天吃着健康的食物瘦下来。接下来带着学到的知识，继续前行，把体重控制回5年前100斤以内。',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703075849996_jpg_wh=800_800.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703074801070_jpg_wh=600_800.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703070364955_png_wh=1080_1551.png',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-20 18:22:47'
    },
    detail: {
      id: 255951,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192200,
          group_id: 255951,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1112297,
        u_name: 'joey',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv4.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 160期毕业学员',
          alias: 'betterWE减脂营 160期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1112297'
        }
      },
      title: '结营感言',
      desc: '通过这63天的减脂，我首先是对自己的腰围肚腩很了很多，特别是我的肚腩，少了6.5cm，对我来说兼职是太开心了，其次是我的体用减了5斤，离目标还有两斤，仍需要努力继续控制饮食分量，和油炸食品say no，最后这一周我碰到瓶颈期了，但是我认为是我的饮食和睡眠导致的，所以还要继续保持良好的作息以及相对清淡的饮食，继续加油，目标是瘦两斤和消灭肚腩，每天做沙漏腰或者是腹部燃脂运动。另外很神奇的一点是我的月经正常了，量也正常了，以前月经量总是很多，找你减脂营之后月经量正常了，这个还是挺惊喜的。\n现在的我会注意吃的食物是否健康，是否是高油高糖，偶尔还是会嘴馋一下，但是总体来说还是控制得挺好的，在这期间还是学会很多减脂的知识的，对减脂也有一定的知识面了，一句话来说，控制嘴，张开腿。\n在此也很感谢男男老师的教导，我体重稍微慢了一些，或者涨了我就会去问她，会着急，但是男男老师也很耐心的跟我分析问题，感谢教导哈。\n减脂不是一天两天的事，而是融入到生活当中，所以还要继续加油，自己学会好减脂的知识以后都知道怎么吃了，革命尚未成功同志仍需努力，加油，向着沙漏腰的目标前进！！！',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703062038685_jpg_wh=2291_2291.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-20 15:46:17'
    },
    detail: {
      id: 255912,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192162,
          group_id: 255912,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 192163,
          group_id: 255912,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1083052,
        u_name: 'Smile',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv5.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 160期毕业学员',
          alias: 'betterWE减脂营 160期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1083052'
        }
      },
      title: '',
      desc: '时间过的很快、一眨眼就到结营的这天了！抖音上看到何洁的vlog让我知道了修贤老师，认识了里里老师、让我有变瘦变美的机会，实话说、一开始也是抱着试试的心态！没想到能够坚持下来、并且拥有这么好的成绩单，以前也没有认认真真去减过肥、就算有想要减肥的想法也会因为方式方法不对导致自己半路放弃坚持不下来，结婚生好小孩后，体重每年都在用肉眼可见的速度递增、这三个月下来、竟然去买了已经很多年没穿过的裤子、并且很好看哦😄！身边的朋友见面就会问，怎么瘦了那么多、我都会分享给朋友！还有一点我觉得很好，授人以鱼不如授人以渔，这是我所喜欢的减肥方式，我在这上面所学习到的知识！我可以受用一辈子、给小孩吃啥都不愁了！我续费了陪伴营、希望可以瘦到自己满意的终极目标！也是接下来我的新目标，里里带我冲吧……',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703066585084_jpg_wh=800_800.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703059303734_jpg_wh=573_751.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703067007053_jpg_wh=550_550.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703060932996_jpg_wh=544_529.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703064302722_jpg_wh=534_538.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-20 15:26:31'
    },
    detail: {
      id: 255905,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192155,
          group_id: 255905,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 192156,
          group_id: 255905,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 7651,
        u_name: '雪落-1',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/userlogo/userlogopro62d8c8dbbe55b83decbc20d665926df9335a0a3be7e3b.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 36期毕业学员',
          alias: 'betterWE减脂营 36期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=7651'
        }
      },
      title: '减脂居然一点不痛苦~',
      desc: '第一次跟这么长时间的训练营，虽然中间🐏了两次，还经历了家里长辈的去世，也没有运动，但还是瘦了5斤多，说实话，对这个数字，我不是很满意，但有的时候真的没有办法…虽然很多意外不是我们能决定的，但体质渣完全是可以改变的！从今天起，按要求喝水，作息，再运动一下下~\n这63天的时间，不得不感谢男男老师，真的好认真负责，只要没有按时打卡，就会过来关心你，“最近怎么了呀，是不是没有好好吃饭？身体不舒服了嘛？”男男老师还好专业，每天都有小课堂，学到了很多东西，相信就算结营了，只要保持住良好的饮食习惯和作息，我也不会再反弹了~表白男男老师哦~',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703049791167_jpg_wh=2291_2291.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 1,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-20 12:24:58'
    },
    detail: {
      id: 255859,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192106,
          group_id: 255859,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 192107,
          group_id: 255859,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1015835,
        u_name: '冒～10号',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv2.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 160期毕业学员',
          alias: 'betterWE减脂营 160期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1015835'
        }
      },
      title: '',
      desc: '84天的减脂营转眼就结束了，瘦了20多斤，我的产假也接近尾声，能带着一个好身材，以良好的状态回归工作，我真的非常开心。我从小就是个胖子，不知是否有遗传的原因，但是我确实很爱吃蛋糕类甜食，有时候吃起来都不会停，体重简直吓人，工作后开始试过代餐，拔罐等减肥方法，也确实都瘦了，但是都要求不吃主食，到后面开始吃主食又胖了起来，反反复复，心累，导致后面怀孕生娃我都担心又要开始减肥了。第一次看到修贤的视频真的半信半疑，三顿都吃主食真的会瘦？观望了很久，因为带娃根本没时间运动，决定试试，真没想到每天吃的饱饱都在掉秤，还学习了很多营养学知识，受益匪浅，有里里老师和减脂营姐妹们陪伴一起瘦，真的是我减肥最轻松最省钱的一次了，结营了还给了小锦囊真的贴心了。今后我要继续好好吃饭，利用学到的营养学知识，加油瘦到理想体重，好好保持，争取最后一次减肥。',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703054150615_jpg_wh=2291_2291.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703049454842_jpg_wh=800_600.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703050967998_jpg_wh=1280_1280.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1703048844474_png_wh=571_735.png',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-20 12:18:42'
    },
    detail: {
      id: 255857,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 192103,
          group_id: 255857,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 192104,
          group_id: 255857,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1226413,
        u_name: '5-小林',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv4.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 168期毕业学员',
          alias: 'betterWE减脂营 168期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1226413'
        }
      },
      title: '减肥真的太多好处了！！',
      desc: '慢慢的掉秤这种幸福感简直不能太快乐🎉 ，看着自己慢慢的变小真的很幸福☺️！最有感而发的就是图一图二，我还没入营前就喜欢这一套衣服了，去服装店试穿穿不上真的很伤心！就下定决心要减肥，在入营期间我又去试了一次还是不行…但是有点满足感是拉链上去了一点。结营后我又续了一次21天。我再去试这一次我穿上了。很轻松😎！！真的太开心了。真的是收获满满就算出去玩也不怕大吃大喝后会涨称…减肥前连p图都是烦恼vs减肥后连p都不用了直接出片',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702799228026_jpg_wh=2221_3571.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702794659256_jpg_wh=3024_4032.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702794960680_jpg_wh=2736_2736.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702792895286_jpg_wh=3024_3024.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702793596306_jpg_wh=3024_3024.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702792445830_jpg_wh=2134_2845.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702793257077_jpg_wh=3024_3024.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 2,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-17 13:41:23'
    },
    detail: {
      id: 255193,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 191435,
          group_id: 255193,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 31563,
        u_name: '34-Fu',
        u_img:
          'https://cdnvue.gymcity.com.cn/uploads/1701679976583656d9368b2fbb.jpg',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 61期毕业学员',
          alias: 'betterWE减脂营 61期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=31563'
        }
      },
      title: '我的120天小结～',
      desc: '已经出营一周了才来总结，实在是这次甲流太厉害真是起不来啊~虽迟但到，我来总结一下我这120天！\n去年最开始参加减脂营还是因为今年要结婚，我确实在结婚前3个月从150瘦到了120斤，但是因为结婚准备流程繁琐、自己压力过大……（反正就是各种各样的小借口吧！）在结婚前一个月我又胖到了130，所以抓紧报了一个陪伴营，但是可能是距离结婚太近也确实没怎么认真听话，在陪伴营老师的帮助下，我128斤穿上了婚纱，虽然没有达到理想体重，但比起之前我也是非常满足啦！\n其实也是因为上次的陪伴营，营期里原本的老师因为工作原因离开了，换成了乌咪老师（和乌咪老师的缘分从这里开始！），我才认识了这么神仙负责的老师，乌咪老师每天都会提醒打卡、喝水，如果有什么问题乌咪老师也都会耐心的和我沟通，不过出营之后就去度蜜月，各种玩耍，我又把自己吃到了150斤，主要身为一个吃货，还有一个吃货的老公真的是伤不起啊。\n在经历了超多思想斗争后，然后我就开始这次的120天，这次我的计划在24年6月份减到110斤，在乌咪老师的帮助下，虽然我在营期中间把腰扭了，经历了好长时间卧床休息，还有一个国庆小长假（在这必须炫耀一下乌咪老师的调整餐，那是相当的牛！我周围好几位同事和我一起吃了7天还收获了5~7的好成绩，她们还惊讶自己都不饿肚子，怎么还会掉秤！），我还是收获了10斤的好成绩。\n好的开始是成功的一半，虽然过程有些波折，我还是会加油，争取在明年达成目标，穿上自己梦想的小裙裙。也期待这是我人生中最后一次减肥~\nPS:我在的小班级非常优秀，班级里的姐妹超级自律，让我见识到了减肥才是最好的医美，每个胖女孩都是潜力股！大家结营时候还在感叹，老师教会我们减肥的原理，让我们可以和食物和平共处，科学减肥，就像是自己掌握了瘦身的神秘钥匙，可以自己控制身材，想瘦就瘦~',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702739083055_jpg_wh=2291_2291.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 1,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 1,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-16 22:06:51'
    },
    detail: {
      id: 255077,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 191320,
          group_id: 255077,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 191321,
          group_id: 255077,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1031238,
        u_name: '31.KK',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1704279774545_jpg_wh=5152_7728.jpg',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 159期毕业学员',
          alias: 'betterWE减脂营 159期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1031238'
        }
      },
      title: '91天',
      desc: '很开心有这么一个91天的，感谢营养师卉卉，餐卡老师菲菲和各位减脂姐妹的一路同行，在这91天里对于营养学有了一定的了解，对于好好吃饭，吃干净健康的饭有了全新的认识，减脂不是一朝一夕的事，它应该会时常陪伴我，以后我将会带着轻松且健康的心态继续前行，相遇即是缘分，祝各位营养师，工作顺利，祝各位减脂姐妹都能够拥有一个健康且自信的生活状态[社会社会]',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702691013842_jpg_wh=2291_2291.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 1,
        is_like: 0
      },
      comment_info: {
        number: 0
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-16 07:23:09'
    },
    detail: {
      id: 254857,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 191103,
          group_id: 254857,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 191104,
          group_id: 254857,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1278472,
        u_name: '两只小熊',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv5.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 169期毕业学员',
          alias: 'betterWE减脂营 169期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1278472'
        }
      },
      title: '感恩！感谢！坚持下去！',
      desc: '21天减脂营结束了，心中非常感谢营养师童童，餐卡老师的指导，让一度以为不运动不节食就瘦身无望的我，瘦了6.4斤！给了我非常大的继续下去的勇气。我是因为怀孕导致了大体重，产后身体不佳没有办法做强烈的有氧运动，只能上私教的课程，虽然有塑形，但是体重不降反升了两斤。那之后对于减脂不敢再燃起希望。几年前还是单身的我，为了追求好身材用过奶昔代餐减脂，效果很明显，但是晚餐节食的痛苦令我记忆犹新，所以我现在再胖也没有再去尝试。无意中抖音刷到修贤老师带何洁瘦身的视频，给我很大触动，不用节食，每餐都可以吃饱，还不用运动就能瘦，这简直为我量身定制，再加上我不太做饭，选用食材上是个难题，所以我决定参加减脂营从最基本的学习。真是感恩这个决定，让我摆脱焦虑，找到了终身受益的健康饮食方法。并且在这期间，童童老师耐心指导，积极的回应，所有的交流都让人感到亲切，真是让我心里生出来的都是积极向上的能量。还有餐卡老师姿丽和雪菲，他们的话语一直是那么的温柔积极，这对于减脂期间情绪容易波动的学员来说非常重要。还有一次我没有坚持，一顿超标的晚餐卡，雪菲老师的寄语里提出了批评，让我及时收起自己的松懈，从那之后我每一餐都是按照标准来，也连续两周获得了优秀餐卡表彰，最后获得了出乎意料的结果，感恩感谢！',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702579386152_jpg_wh=1024_1024.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702580893205_jpg_wh=1080_1080.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 3,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-15 00:21:42'
    },
    detail: {
      id: 254513,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 190776,
          group_id: 254513,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 190777,
          group_id: 254513,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 1010735,
        u_name: '13-冬冬',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv2.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 159期毕业学员',
          alias: 'betterWE减脂营 159期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=1010735'
        }
      },
      title: '',
      desc: '抱着试试看的心理参加了84天的减脂营，在这之前各种减肥方法均踩过坑，不吃就瘦，一吃反弹的特别快。通过营养师的指导以及基础营养学知识的学习，让我的观念彻底改变，养成了健康的饮食习惯，不再无辣不欢，而是营养均衡，清淡饮食，身边的朋友都说我瘦了，也不再玻璃心，不再因为体重的一点点上涨就开始焦虑。营养师全程指导，只要按时上传餐卡，营养师都会根据情况做出具体调整给出详细的建议。非常实用，也非常感谢营养师。目前我仍然保持3天一上秤的习惯，虽偶有贪嘴，但也确信通过饮食调整会瘦下来。今后的自己会继续坚持，瘦到目标体重。',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702477964973_jpg_wh=1280_1280.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 3,
        is_like: 0
      },
      comment_info: {
        number: 1
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-13 20:51:18'
    },
    detail: {
      id: 254123,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 190387,
          group_id: 254123,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 190388,
          group_id: 254123,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  },
  {
    type: 1,
    base: {
      user: {
        unify_id: 246944,
        u_name: '1-浅沫',
        u_img:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_normal_avatar_nv5.png',
        is_follow: 0,
        label_data: {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49532ddc0c1539c97a8f71d4c2b12cf7.png',
          name: 'betterWE减脂营 136期毕业学员',
          alias: 'betterWE减脂营 136期毕业学员',
          weight: 86,
          jump_router: '/userDetailsPage?id=246944'
        }
      },
      title: '',
      desc: '很开心参加这次90天减脂旅程，让我不再陷入减脂的怪圈，谢谢六六老师的陪伴和细心开导，不再因为体重的涨幅而焦虑不安，因为六六会帮我及时调整（六六老师真的很有耐心，会积极响应给我明确的方向和建议，帮我搭配的饮食小基数也能轻松瘦掉2CM腰围 ），这次真的让我在不经意间改掉了暴食暴食的习惯，也不再馋高热量食物（以前的我总是反复焦虑，反复暴饮暴食，心情不好就会乱吃高热量零食，减脂课程里的心理课程真的很有用），现在的我渐渐更倾向于选择健康的食材，学会了饮食搭配，养成了规律饮食的好习惯，永远不要轻易放弃自己，要相信自己是最棒的（学会接受自己的不完美，与自己和解，减脂效果也会翻倍），很开心有群里姐妹们的陪伴，因为有相同目标让我们聚在一起，虽然平时因为工作忙，没有太多的沟通，但是也很高兴有你们的陪伴，让我不孤单，嘿嘿，也感谢可爱的姗姗小老师每一餐都很细心点评及每日分享一个减脂小技巧，虽然我还没有瘦到自己的目标体重，但是我会在后面时间里，继续保持好好吃饭的好习惯，每一天的努力定不会辜负现在的你，加油，姐妹们!',
      image_list: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702471486027_jpg_wh=1080_1440.jpg',
          width: '',
          height: ''
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1702466363590_jpg_wh=2160_2160.jpg',
          width: '',
          height: ''
        }
      ],
      like_info: {
        number: 3,
        is_like: 0
      },
      comment_info: {
        number: 2
      },
      collect_info: {
        number: 0,
        is_collect: 0,
        collect_id: null
      },
      create_time: '2023-12-13 18:56:21'
    },
    detail: {
      id: 254112,
      tab_type: 'weapp_group_unify',
      content_type: 1,
      video_info: null,
      topic_data: [
        {
          id: 190374,
          group_id: 254112,
          topic_id: 76,
          topic: '我的专属营养师'
        },
        {
          id: 190375,
          group_id: 254112,
          topic_id: 8,
          topic: '结营感言'
        }
      ]
    }
  }
]
export { dynamicList }
